import { render } from "./SearchComponent.vue?vue&type=template&id=b2ff8bc2&scoped=true&ts=true"
import script from "./SearchComponent.vue?vue&type=script&lang=ts"
export * from "./SearchComponent.vue?vue&type=script&lang=ts"

import "./SearchComponent.vue?vue&type=style&index=0&id=b2ff8bc2&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2ff8bc2"]])

export default __exports__